// import "./App.css";
import { MainPage } from "./Pages/MainPage";
import { Route, Routes } from "react-router-dom";
import {ChatPage} from "./Pages/ChatPage";
import { AboutPage } from "./Pages/AboutPage";
import { ForBusinessPage } from "./Pages/ForBusinessPage";
import { ProfilePage } from "./Pages/ProfilePage";
import { NotFoundPage } from "./Pages/NotFoundPage";

function App() {
    return (
        <div className="App">
            <Routes>
                <Route path="/" element={<MainPage />} />
                <Route path="/chat" element={<ChatPage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/business" element={<ForBusinessPage />} />
                <Route path="/profile" element={<ProfilePage />} />
                <Route path="*" element={<NotFoundPage />} />
            </Routes>
        </div>
    );
}

export default App;